/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FantaBoosterType {
    GOAL_KING = 'goal_king',
    CAPTAIN = 'captain',
}
